export interface AmountFilter {
    minAmount?: string;
    maxAmount?: string;
}

export interface DateFilter {
    startDate?: string;
    endDate?: string;
}

export enum DirectionFilter {
    INCOMING = 'INCOMING',
    OUTGOING = 'OUTGOING',
    ALL = 'ALL',
}

export interface BillIdRangeFilter {
    billIdFrom?: string;
    billIdTo?: string;
}

export type BooleanAsString = 'true' | 'false';

export type KeywordFilter = string;
